import { TransactionFormField } from "../../components/Transactions/Components/Form/config/config";
import { IAutomationExecutionResult } from "../../config/automation";

export const shareWithFriendsFixedCallback = (payload: any): IAutomationExecutionResult | undefined => {
    const errors = [];
    if (!!payload) {
        if (!payload.name) {
            errors.push('<name> property is missing in the payload');
        }
        if (!payload.split_method) {
            errors.push('<split_method> property is missing in the payload');
        }
        if (!payload.amount) {
            errors.push('<amount> property is missing in the payload');
        }
    }

    if (!!errors.length) {
        console.error('shareWithFriendsFixedCallback', errors);
        return;
    }

    return {
        fieldKey: TransactionFormField.AMOUNT_SHARING,
        field: 'splits',
        data: payload,
    };
};

export const shareWithFriendsPercentageCallback = (payload: any): IAutomationExecutionResult | undefined => {
    const errors = [];
    if (!!payload) {
        if (!payload.name) {
            errors.push('<name> property is missing in the payload');
        }
        if (!payload.split_method) {
            errors.push('<split_method> property is missing in the payload');
        }
        if (!payload.percentage) {
            errors.push('<percentage> property is missing in the payload');
        }
    }

    if (!!errors.length) {
        console.error('shareWithFriendsPercentageCallback', errors);
        return;
    }

    return {
        fieldKey: TransactionFormField.AMOUNT_SHARING,
        field: 'splits',
        data: payload,
    };
};
